import * as React from 'react';
import {Badge, IconButton, Stack, Tooltip, useMediaQuery, useTheme} from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import {ThemeSwitcher} from '@toolpad/core/DashboardLayout';
import {Account} from '@toolpad/core/Account';
import {useTranslation} from 'react-i18next';
import {LanguageSwitcher} from './LanguageSwitcher';
import {PeriodBranchToolbarSelector} from './PeriodBranchToolbarSelector';

// Desktop: account/logout lives in the sidebar footer (see SidebarFooterAccount), and Language
// selection sits last, after the period/branch selector, taking the trailing spot the account
// menu used to occupy. Mobile (see the mobile dashboard design reference): the account menu stays
// in the top-right header - like before - period/branch move out of this toolbar entirely
// (rendered as their own full-width row above the page content, see MobilePeriodBranchFilterBar),
// and the language switcher is kept (compact) since it isn't reachable anywhere else on mobile.
export function DashboardToolbarActions(): React.ReactElement {
    const {t} = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const notifications = (
        <Tooltip title={t('common.toolbar.notifications')}>
            <IconButton aria-label="notifications">
                <Badge badgeContent={3} color="error">
                    <NotificationsNoneIcon/>
                </Badge>
            </IconButton>
        </Tooltip>
    );

    if (isMobile) {
        return (
            <Stack direction="row" alignItems="center" spacing={1}>
                {notifications}
                <LanguageSwitcher/>
                <Account/>
            </Stack>
        );
    }

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <PeriodBranchToolbarSelector/>
            {notifications}
            <ThemeSwitcher/>
            <LanguageSwitcher/>
        </Stack>
    );
}
